import { ReactNode } from "react";

import { InteractionMode } from "components/server-types";
import { ClassCollaborationIcon, PersonGroupIcon, PersonSingleIcon } from "mds/icons";

export const INTERACTION_MODE_ICONS: Record<InteractionMode, ReactNode> = {
  [InteractionMode.INDIVIDUAL]: <PersonSingleIcon size="xs" />,
  [InteractionMode.SHARED_CLASS]: <ClassCollaborationIcon size="xs" />,
  [InteractionMode.ASSIGN_STUDENTS]: <PersonGroupIcon size="xs" />,
  [InteractionMode.SELF_ASSIGN]: <PersonGroupIcon size="xs" />,
  [InteractionMode.STATIC]: null,
};

export const INTERACTION_MODE_COLORS = {
  [InteractionMode.INDIVIDUAL]: "text-blue bg-blue-tint-95 border-blue-tint-70",
  [InteractionMode.SHARED_CLASS]: "text-moss bg-moss-tint-95 border-moss-tint-70",
  [InteractionMode.ASSIGN_STUDENTS]: "text-hibiscus bg-hibiscus-tint-95 border-hibiscus-tint-70",
  [InteractionMode.SELF_ASSIGN]: "text-hibiscus bg-hibiscus-tint-95 border-hibiscus-tint-70",
};

// TODO: the following might not belong here
export const CHIP_BASE_CLASSNAME =
  "text-xs font-medium flex cursor-default items-center justify-center gap-1.5 whitespace-nowrap rounded-3xl border px-3 h-[28px]";

export const ORANGE_CHIP_CLASSNAME = "text-orange-shade-40 bg-orange-tint-90 border-orange-tint-70";
export const RED_CHIP_CLASSNAME = "text-red-shade-20 bg-red-tint-93 border-red-tint-70";
export const WHITE_CHIP_CLASSNAME = "text-black-tint-20 bg-black-tint-99 border-black-tint-90";

export const PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE = "@[450px]/page-metadata:hidden";
export const PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW = "@[450px]/page-metadata:inline";
